import { Mutations } from '@shared/api';
import { getSharedApolloClient } from '@shared/api/client';

export async function notifyPendingUsers(messageId: number) {
  const apolloClient = getSharedApolloClient();
  await apolloClient.mutate({
    mutation: Mutations.chat.sendToPendingUsers,
    variables: { messageId },
  });
}
